import Flags from "country-flag-icons/react/3x2";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { putChangeLanguage } from "shared/service/StrmService";
import "./LanguageChange.scss";
import { setCountryOptionsI18n } from "explorer/reducers/countries";
import { setGenreOptionsI18n } from "explorer/reducers/generos";
import { autenticado } from "shared/helpers/auth-functions";

const LanguageChange: React.FC = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const loggedUser = useSelector((state: any) => state.users.loggedUser);
  const { genres } = useSelector((state: any) => state.genres);
  const { countries } = useSelector((state: any) => state.countries);

  const setCountryOptions = useCallback(async () => {
    if (countries) {
      dispatch(setCountryOptionsI18n(i18n.language));
    }
  }, [countries, dispatch, i18n]);

  const setGenreOptions = useCallback(async () => {
    if (genres) {
      dispatch(setGenreOptionsI18n(i18n.language));
    }
  }, [genres, dispatch, i18n]);

  const onChangeLanguage = (lang: string) => {
    if (loggedUser?.currentLanguage && autenticado()) putChangeLanguage(lang);
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    setGenreOptions();
    setCountryOptions();
  };

  useEffect(() => {
    setCountryOptions();
    setGenreOptions();
  }, [setCountryOptions, setGenreOptions]);

  return (
    <div className="change-language">
      <Flags.US onClick={() => onChangeLanguage("en")} />
      <Flags.BR onClick={() => onChangeLanguage("pt")} />
      <Flags.ES onClick={() => onChangeLanguage("es")} />
    </div>
  );
};

export default LanguageChange;
